document.addEventListener('DOMContentLoaded', (e) => {
	// MB Rhetoric Slick slider
	if (document.querySelector('.rhetoric__slide .item-list > ul')) {
		jQuery('.rhetoric__slide .item-list > ul')
			.not('.slick-initialized')
			.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow:
					'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><span class="visually-hidden">Next</span><span class="a-icon__left_arrow"></span></button>',
				nextArrow:
					'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><span class="visually-hidden">Next</span><span class="a-icon__right_arrow"></span></button>',
				responsive: [
					{
						breakpoint: 590,
						settings: {
							arrows: false,
							centerMode: false,
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
				],
			});
	}
});
